import { markAsRead } from "@/services";
import { NOTIFICATION_QUERY_KEYS } from "@/types";
import { toastApiError } from "@/utils/toastApiError";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export function useMarkAsRead() {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationKey: [NOTIFICATION_QUERY_KEYS.MARK_AS_READ],
    mutationFn: (ids: number[]) => markAsRead(ids),
    onSuccess: () => {
      // Reset api unreach count
      queryClient.invalidateQueries({
        queryKey: [NOTIFICATION_QUERY_KEYS.UNREAD_COUNT],
      });
      // Reset api list my notifications cache to refetch
      queryClient.invalidateQueries({
        queryKey: [NOTIFICATION_QUERY_KEYS.MY_NOTIFICATIONS],
      });
    },
    onError: toastApiError,
  });

  return { markAsRead: mutateAsync, isPending };
}
